import { render, staticRenderFns } from "./editConfig.vue?vue&type=template&id=3bfba880&scoped=true&"
import script from "./editConfig.vue?vue&type=script&lang=ts&"
export * from "./editConfig.vue?vue&type=script&lang=ts&"
import style0 from "./editConfig.vue?vue&type=style&index=0&id=3bfba880&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bfba880",
  null
  
)

export default component.exports